import { toaster } from '@/components/ui'
import { useGqlQuerySuspense } from '@/lib/api'
import { graphql } from '@/lib/gql'

const getAttachmentQuery = graphql(`
  query GetAttachment($inquiryMessageAttachmentUid: UUID!) {
    inquiryMessageAttachment(
      inquiryMessageAttachmentUid: $inquiryMessageAttachmentUid
    ) {
      uploadedFile {
        url(mode: Attachment)
      }
    }
  }
`)

type Props = {
  inquiryMessageAttachmentUid: string
}

export const AttachmentPage = ({ inquiryMessageAttachmentUid }: Props) => {
  useGqlQuerySuspense(
    {
      document: getAttachmentQuery,
      variable: {
        inquiryMessageAttachmentUid,
      },
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      onSuccess: data => {
        const attachmentUrl = data.inquiryMessageAttachment.uploadedFile.url
        window.open(attachmentUrl, '_blank', 'noopener,noreferrer')
        toaster.create({
          type: 'success',
          description: '1件のファイルをダウンロードしました',
        })
      },
    },
  )

  return null
}
